import {FormDataType} from 'api/types/LeadForm';

export enum VIEW {
    mobile = 'mobile',
    miniapp = 'miniapp',
    overlay = 'overlay',
    fullscreen = 'fullscreen',
}

export type SendLeadYClientsResponse =
    | {
          http_status_code: number;
          status: boolean;
          message?: string;
      }
    | false;

export type DataState = {
    data: FormDataType | null;
    status: number | null;
};

export type VKWebAppGetCustomSdkUserInfoResult = {
    first_name?: string;
    last_name?: string;
    city?: string;
    /**
     * Date of Birth. It is returned in the format D.M.YYYY or D.M (if the
     * year of birth is hidden). If the date of birth is hidden entirely,
     * the field is not in the response.
     */
    bdate?: string;
    phone?: string;
    phone_sign?: string; // в случае если телефон маскированный, а подписи нет - вставляем просто не пустую строку с любым значением. Для расшифровки телефона из почты например нужен только access_token без подписи, но на подпись у нас завязана проверка нужно ли запрашивать данные или нет
    email?: string;
    email_sign?: string; // тоже самое как с подписью телефона
    decode_params?: {
        // если есть подпись у телефона или почты - обязательное
        access_token?: string; // опциональный, обязательный для всех кроме вк/ок
        user_id?: string; // опциональный (для вк/ок обязательный в данный момент, в остальных не используем)
        app_id: string; // обязательный
    };
    vk_id?: number;
};

export type MergedFillData = Pick<
    VKWebAppGetCustomSdkUserInfoResult,
    'phone' | 'email' | 'phone_sign' | 'email_sign'
> & {
    phone_data?: VKWebAppGetCustomSdkUserInfoResult['decode_params'];
    email_data?: VKWebAppGetCustomSdkUserInfoResult['decode_params'];
};

export type VkCapthaInfoResponse =
    | {
          show_captcha: false;
      }
    | {
          show_captcha: true;
          captcha_session: {
              captcha_url: string;
              session_token: string;
          };
      };

export enum CHECK_CAPTCHA_STATUS {
    'success',
    'error',
    'cancel',
}

export type checkCaptchaResult =
    | {
          status: CHECK_CAPTCHA_STATUS.error | CHECK_CAPTCHA_STATUS.cancel;
      }
    | {
          status: CHECK_CAPTCHA_STATUS.success;
          token: string;
      };

// Типы для метрик
export type LoadResourceMetrics = {
    phases: ResourcePhases;
    url: string;
    transfer_size: number; // Сжатый размер переданных данных в kb
    size: number; // Несжатый размер ресурса в kb
    time_in_ms: number; // Общее время загрузки в ms
    type: ResourceMetaType; // Тип ресурса
    // timestamps: ResourceTimings; // пока не используем, оставим на будущее
};

// type ResourceTimings = {
//     fetchStart: number;
//     requestStart: number;
//     responseStart: number;
//     responseEnd: number;
// };

type ResourcePhases = {
    dns_lookup: number; // время DNS-поиска
    tcp_handshake: number; // время установки TCP-соединения
    ssl_negotiation: number; // время TLS-рукопожатия
    waiting: number; // время ожидания (TTFB)
    content_download: number; // время загрузки контента
};

// Типы для ошибок ресурсов
export type LoadResourceErrorType = 'img' | 'css' | 'script' | 'favicon' | 'video' | 'other';

export type ResourceMetaType = LoadResourceErrorType | 'fetch';

export type LoadResourceError = {
    type: LoadResourceErrorType;
    url: string;
    message?: string;
};
